import Vue from 'vue'
import VueRouter from 'vue-router'

/* 开启debug模式 */
// Vue.config.debug = true
Vue.use(VueRouter)

import NotFound from '../pages/404.vue'
import Versus from '../pages/versus.vue'
import Help from '../pages/help.vue'

export default new VueRouter({
  mode: 'history',
  base: __dirname,
  routes: [
    {
      path: '/',
      component: NotFound
    },
    {
      path: '/measurements/versus/:code',
      component: Versus
    },
    {
      path: '/measurements/help',
      component: Help
    },
    { path: '*', redirect: '/' }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js